import { render, staticRenderFns } from "./CRUDTemplatesMensagens.vue?vue&type=template&id=2704b13e&scoped=true&"
import script from "./CRUDTemplatesMensagens.vue?vue&type=script&lang=js&"
export * from "./CRUDTemplatesMensagens.vue?vue&type=script&lang=js&"
import style0 from "./CRUDTemplatesMensagens.vue?vue&type=style&index=0&id=2704b13e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2704b13e",
  null
  
)

export default component.exports